import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges, ChangeDetectorRef, Inject } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { ErrorService } from 'src/app/services/Dossier/error.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PayslipCollection } from 'src/app/classes/dossier/payslip-collection';
import { DocumentService } from 'src/app/services/Dossier/document.service';
import { Document } from 'src/app/classes/dossier/document';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-read-documents-payslip',
    templateUrl: './read-documents.component.html',
    styleUrls: ['./read-documents.component.scss']
})
export class ReadDocumentsComponent implements OnInit {

    dossierId;
    dossier;
    payslipCollection: PayslipCollection;
    documents = [];
    types;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ReadDocumentsComponent>,
        private appService: AppService,
        private documentService: DocumentService,
        private errorService: ErrorService,
        private httpClient: HttpClient
    ) {}

    ngOnInit(): void {
        this.payslipCollection = new PayslipCollection([]);
        this.dossierId = this.data["dossierId"];
        this.getPayslipsFromDossier();
        this.getDocumentsFromDossier();
        this.loadDocumentTypes();
    }

    getPayslipsFromDossier()  {
        this.appService.getDossierById(this.dossierId).subscribe((response) => {
            this.dossier = response.result.datas[0];
            this.setNewerPayslips(this.dossier);
            this.payslipCollection.setPayslips(this.dossier["bulletinSalaire"], false);
        });
    }

    setNewerPayslips(dossier) {
        let datecobham = dossier.datecobham ? new Date(dossier.datecobham) : Date.now();
        dossier.bulletinSalaire = dossier.bulletinSalaire
            .sort(a => (a.typepage == "P" ? 1 : -1))
            .sort((a, b) => (a.datedebutbs > b.datedebutbs ? 1 : -1))
            .filter((bulletin) => {
                bulletin.new = datecobham < new Date(bulletin.datecreation); 
                return [bulletin]; 
            });
    }

    getDocumentsFromDossier() {
        this.documentService.getDocumentsFromDossier(this.dossierId).subscribe((res) => {
            if (res.result.documents) {
                this.createDocuments(res.result.documents);
            }
        });
    }

    createDocuments(documents) {
        documents.map( (document) => {
            this.documents.push(new Document(document));
        })
    }

    loadDocumentTypes() {
        this.httpClient.get('assets/document-delegation.json?v=' + window['cobham_version'])
        .subscribe((res) => {
            this.types = res["diagnostic"]["types"];
        })
    }

    dismissDialog() {
        this.dialogRef.close();
    }
}